// import { Link } from 'react-router-dom'
import { Card, Button, Badge } from '@/components/common'

interface ServiceCardProps {
  service: {
    id: 'blis' | 'izg'
    name: string
    title: string
    description: string
    icon: string
    iconColor: string
    subscriptionStatus?: 'pending' | 'active' | 'trial' | 'expired' | 'none'
    subscriptionPlan?: string
  }
}

export const DashboardServiceCard: React.FC<ServiceCardProps> = ({ service }) => {
  const statusColors = {
    pending: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400',
    active: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
    trial: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
    expired: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
    none: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300',
  }

  const statusLabels = {
    pending: 'Pending Approval',
    active: 'Active',
    trial: 'Trial',
    expired: 'Expired',
    none: 'Not Subscribed',
  }

  return (
    <Card className="relative overflow-hidden">
      <div
        className={`absolute right-0 top-0 h-32 w-32 -translate-y-8 translate-x-8 rounded-full ${
          service.id === 'blis'
            ? 'bg-blue-100 dark:bg-blue-900/30'
            : 'bg-emerald-100 dark:bg-emerald-900/30'
        } opacity-50 blur-2xl`}
      ></div>
      <div className="relative z-10">
        <div className="flex items-start justify-between mb-4">
          <div className={`rounded-lg ${service.iconColor} p-3`}>
            <span className="material-symbols-outlined !text-3xl">{service.icon}</span>
          </div>
          {service.subscriptionStatus && (
            <Badge
              variant={
                service.subscriptionStatus === 'active'
                  ? 'success'
                  : service.subscriptionStatus === 'trial'
                  ? 'default'
                  : service.subscriptionStatus === 'pending'
                  ? 'warning'
                  : service.subscriptionStatus === 'expired'
                  ? 'danger'
                  : 'default'
              }
              className={statusColors[service.subscriptionStatus]}
            >
              {statusLabels[service.subscriptionStatus]}
            </Badge>
          )}
        </div>

        <h3 className="text-2xl font-bold mb-2 text-text-main-light dark:text-text-main-dark">
          {service.name}
        </h3>
        <p className="text-lg font-semibold mb-2 text-text-main-light dark:text-text-main-dark">
          {service.title}
        </p>
        <p className="text-text-sub-light dark:text-text-sub-dark mb-4">
          {service.description}
        </p>

        {service.subscriptionPlan && (
          <div className="mb-4 p-3 bg-gray-50 dark:bg-gray-800/50 rounded-lg">
            <p className="text-sm text-text-sub-light dark:text-text-sub-dark">
              Current Plan:
            </p>
            <p className="text-sm font-semibold text-text-main-light dark:text-text-main-dark">
              {service.subscriptionPlan}
            </p>
          </div>
        )}

        {/* Only show buttons when subscription status is active */}
        {service.subscriptionStatus === 'active' && (
          <div className="flex gap-2">
            <Button
              variant="primary"
              size="sm"
              // as={Link}
              // to={`/services/${service.id}/demo`}
              className="flex-1"
            >
              View Demo
            </Button>
          </div>
        )}
      </div>
    </Card>
  )
}

